import React from 'react';

const WhisperIcon = ({ size = 28, className = "" }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 28 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ filter: 'drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.3))' }}
    >
      {/* Square conversation bubble - larger size */}
      <rect 
        x="3" 
        y="5" 
        width="16" 
        height="12" 
        rx="2.5" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        fill="none"
      />
      
      {/* Chat bubble tail pointing RIGHT - much larger and more prominent */}
      <path 
        d="M19 7 L26 11 L19 15 Z" 
        fill="currentColor"
      />
      
      {/* Three dots inside bubble - larger and more prominent */}
      <circle cx="7.5" cy="11" r="1.2" fill="currentColor" />
      <circle cx="11.5" cy="11" r="1.2" fill="currentColor" />
      <circle cx="15.5" cy="11" r="1.2" fill="currentColor" />
    </svg>
  );
};

export default WhisperIcon;
